import { c as _c } from "react/compiler-runtime";
import { chakra } from '@chakra-ui/react';
import { parseRagContentRef, RagSourceHoverCard } from '@src/components/sco/MarkdownRenderer/RagSourceHoverPreview';
import { MentionElement } from '@src/components/sco/RichMarkdownInput/components/elements/MentionElement';
import { isValidElement, ReactNode } from 'react';
type MarkdownLinkProps = {
  children?: React.ReactNode;
  href?: string;
};
function extractLinkLabel(node: ReactNode): string | undefined {
  if (node == null || typeof node === 'boolean') {
    return undefined;
  }
  if (typeof node === 'string' || typeof node === 'number') {
    return String(node);
  }
  if (Array.isArray(node)) {
    const parts = node.map(extractLinkLabel).filter(Boolean);
    return parts.length ? parts.join('') : undefined;
  }
  if (isValidElement(node)) {
    return extractLinkLabel((node.props as {
      children?: ReactNode;
    }).children);
  }
  return undefined;
}
export const MarkdownLink = t0 => {
  const $ = _c(14);
  let props;
  let t1;
  let t2;
  let target;
  if ($[0] !== t0) {
    t2 = Symbol.for("react.early_return_sentinel");
    bb0: {
      props = t0 === undefined ? {} : t0;
      target = "";
      if (props.href?.startsWith("mention:user:")) {
        t2 = <MentionElement element={{
          mentionable: {
            label: `${props.children?.props?.children || props.children || "Mention"}`.replace("@", ""),
            identifier: props.href
          },
          children: null
        }} />;
        break bb0;
      }
      t1 = props.href?.toLowerCase()?.startsWith("http");
    }
    $[0] = t0;
    $[1] = props;
    $[2] = t1;
    $[3] = t2;
    $[4] = target;
  } else {
    props = $[1];
    t1 = $[2];
    t2 = $[3];
    target = $[4];
  }
  if (t2 !== Symbol.for("react.early_return_sentinel")) {
    return t2;
  }
  if (t1) {
    target = "_blank";
  }
  let t3;
  if ($[5] !== props || $[6] !== target) {
    t3 = <chakra.a {...props} target={target}>{props.children}</chakra.a>;
    $[5] = props;
    $[6] = target;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  const link = t3;
  if (parseRagContentRef(props.href)) {
    let t4;
    if ($[8] !== props.children) {
      t4 = extractLinkLabel(props.children);
      $[8] = props.children;
      $[9] = t4;
    } else {
      t4 = $[9];
    }
    let t5;
    if ($[10] !== link || $[11] !== props.href || $[12] !== t4) {
      t5 = <RagSourceHoverCard fallbackTitle={t4} href={props.href}>{link}</RagSourceHoverCard>;
      $[10] = link;
      $[11] = props.href;
      $[12] = t4;
      $[13] = t5;
    } else {
      t5 = $[13];
    }
    return t5;
  }
  return link;
};